import React from 'react'; // import React from 'react';
import ReactDOM from 'react-dom/client'; // import ReactDOM from 'react-dom'. Nos sirve para renderizar el componente en el DOM. Esto signnifica que el componente se mostrará en la pantalla. El DOM es la estructura de objetos que representa la página web. ReactDOM es una librería que nos permite manipular el DOM de una forma más sencilla.
import './theme/tokens.css';
import './index.css';
// Al final a propósito: sus reglas de `:root` en `@media print` tienen que
// ganar por orden de fuente sobre el bloque oscuro de `tokens.css`.
import './theme/print.css';
import App from './App';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
